module.exports = __webpack_public_path__ + "img/Mixed-fruits-400x263.2f1d82fd.jpg";